import { Box, Container } from "@mui/material";
import React from "react";

const PrivacyPolicyView = () => {
  return (
    <div>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <div>
          <div className="landing-bg_biggpay_font">Privacy Policy</div>
          <Box
            style={{
              width: "60px",
              height: "10px",
              backgroundColor: "#dc5f5f",
            }}
          ></Box>
          <Box sx={{ mt: 3 }}>
            <div>
              <p className="landing-bg_para">
                We2Pay India Limited (
                <strong>“We2Pay”, “we”, “us”, “our”</strong>), respects every
                individual’s right to privacy and it is our endeavour to protect
                their personal and Sensitive personal data or information
                (defined below).
              </p>
              <p className="landing-bg_para">
                This Privacy Policy (<strong>“Policy”</strong>) applies to all
                visitors (i.e. those who do not have an Account with We2Pay) and
                users (i.e. those who have an Account with We2Pay) (collectively
                referred to as
                <strong>“User”</strong>) who share their personal and Sensitive
                personal data with us, while visiting, accessing, browsing and
                using our website and mobile application (collectively referred
                to as
                <strong>“Website”</strong>). The purpose of this Policy is to
                inform Users regarding collection, use, storage, transfer and
                disclosure of their data. Before submitting any information to
                us, please carefully read this Policy to understand how we shall
                treat your information.
              </p>
              <p className="landing-bg_para">
                The User acknowledges that this Policy is a part of We2Pay’s
                <strong>Terms &amp; Conditions available at</strong>
                <a href="/terms&condition">Terms &amp; Conditions</a> and all
                terms defined in the Terms of Use have the same meaning here in
                this Policy. Access, browsing and continuous use of the Website
                constitutes the User’s unconditional consent to this Policy read
                together with the Terms of Use. If the User does not agree with
                the terms of this Policy, please do not visit and use our
                Website. This Policy can be easily accessed at various places on
                our Website, including but not limited to when Users create an
                account with us on our Website.
              </p>
              <p className="landing-bg_para">
                We2Pay reserves its right to modify, alter, and update this
                Policy at any time, with or without prior notice. Although,
                Users shall be notified of material changes through their
                registered email address or any other mode of communication
                available with us, it is advised that they consult this Policy
                regularly to be updated about the changes. If a User continues
                to use or avail the services of the Website after any
                modification, amendment, alteration or change of this Policy,
                irrespective of whether notice was sent to the User or published
                on the Website, such User is hereby deemed to provide consent to
                this Policy and We2Pay’s other Policies and practices existing
                at the time of visiting, accessing and/or using the Website.
              </p>

              <div className="landing-bg_para">
                This Policy is published in compliance of:
              </div>
              <div className="custom-list points text-secondary pt-1">
                <div className="landing-bg_para">
                  Section 43A of the Information Technology Act, 2000 (
                  <strong>“Act”</strong>)
                </div>
                <div className="landing-bg_para">
                  Regulation 4 of the Information Technology (Reasonable
                  Security Practices and Procedures and Sensitive Personal
                  Information) Rules, 2011 (<strong>“SPI Rules”</strong>)
                </div>
              </div>

              <div className="landing-bg_para">
                <h3 className="landing-bg_para">Definitions</h3>
              </div>
              <div className="landing-bg_para">
                <div>
                  <span className="pb-2">
                    <strong>Personal Information</strong>
                  </span>
                  <div className="landing-bg_para">
                    SPI Rules define “Personal Information” as any information
                    that relates to a natural person, which, either directly or
                    indirectly, in combination with other information available
                    or likely to be available with a body corporate, is capable
                    of identifying such person. Such information includes name,
                    address, mobile number, etc.
                  </div>
                </div>
                <div className="landing-bg_para">
                  <span>
                    <strong>Sensitive personal data or information</strong>
                  </span>
                  <div>
                    SPI Rules define “Sensitive personal data or information” of
                    a person as personal information which consists of
                    information relating to:
                  </div>
                  <div className="landing-bg_para">
                    <div className="landing-bg_para">passwords;</div>
                    <div className="landing-bg_para">
                      financial information such as bank accounts or credit card
                      or debit card or other payment instrument details;
                    </div>
                    <div className="landing-bg_para">
                      physical, physiological and mental health condition;
                    </div>
                    <div className="landing-bg_para">sexual orientation;</div>
                    <div className="landing-bg_para">
                      medical records and history;
                    </div>
                    <div className="landing-bg_para">
                      biometric information;
                    </div>
                    <div className="landing-bg_para">
                      any of the information received under above clauses by
                      body corporate for processing or storage under lawful
                      contract or otherwise.
                    </div>
                  </div>
                  <p className="landing-bg_para">
                    Information which is freely available in the public domain
                    or furnished under the Right to Information Act, 2005 or any
                    other law shall not be regarded as sensitive personal data
                    or information.
                  </p>
                </div>

                <div className="landing-bg_para">
                  <span>
                    <strong>Payment Data</strong>
                  </span>
                  <div className="landing-bg_para">
                    “Payment Data” is defined as end-to-end transaction details
                    and information pertaining to payment or settlement
                    transaction that is gathered / transmitted / processed as
                    part of a payment message / instruction. Payment Data
                    includes - Customer data (Name, Mobile Number, email,
                    Aadhaar Number, PAN number, etc. as applicable); Payment
                    sensitive data (customer and beneficiary account details);
                    Payment Credentials (OTP, PIN, Passwords, etc.); and,
                    Transaction data (originating &amp; destination system
                    information, transaction reference, timestamp, amount,
                    etc.).
                  </div>
                </div>
              </div>

              <div className="landing-bg_para">
                <h3 className="h5">
                  Consent for collection of Personal Information
                </h3>
              </div>
              <p className="landing-bg_para">
                Users provide their consent to the use, disclosure, storage,
                possession, receiving, dealing or handling of their Personal
                Information by accessing, browsing, or availing services on the
                Website.
              </p>
              <p className="landing-bg_para">
                In accordance with Rule 5 of SPI Rules, Users provide their
                specific consent to the use, disclosure, storage, possession,
                receiving, dealing or handling of their Sensitive personal data
                or information for lawful purposes enumerated in this policy
                through checking the box affirming such consent appearing at the
                time of creation of their Account on the Website.
              </p>
              <p className="landing-bg_para">
                We2Pay presumes adequate and lawful parental consent in case the
                Personal Information or Sensitive personal data or information
                is shared by a User under the age of 18 years.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">Types of information we collect</h3>
              </div>
              <p className="landing-bg_para">
                The Users who access and use our Website are required to submit
                certain Personal Information and Sensitive personal data or
                information for creating an Account, entering into transactions
                with us and obtaining customer support services. Personal
                Information and Sensitive personal data or information which may
                be collected by us includes:
              </p>
              <div className="landing-bg_para">
                <div className="landing-bg_para">full name and age;</div>
                <div className="landing-bg_para">username and password;</div>
                <div className="landing-bg_para">PAN;</div>
                <div className="landing-bg_para">
                  password of User’s account registered with us;
                </div>
                <div className="landing-bg_para">postal address;</div>
                <div className="landing-bg_para">E-mail address;</div>
                <div className="landing-bg_para">mobile number;</div>
                <div className="landing-bg_para">
                  internet protocol (IP) addresses (through cookies);
                </div>
                <div className="landing-bg_para">
                  URL of website accessed prior to and post Users’ accessing our
                  Website;
                </div>
                <div className="landing-bg_para">
                  credit/debit card number, credit/debit card expiration date
                  and/or other payment instrument details;
                </div>
                <div className="landing-bg_para">
                  User’s feedback, queries, e-mails, letters, suggestions
                  provided to us;
                </div>
                <div className="landing-bg_para">
                  third party information about concerned User’s activities or
                  postings on the Website;
                </div>
                <div className="landing-bg_para">
                  Information about the mobile/tab device the App is installed
                  on or mobile device identifier.
                </div>
                <div className="landing-bg_para">
                  any other information relevant for accessing and using our
                  Website as maybe required by us.
                </div>
              </div>

              <div className="landing-bg_para">
                <h3 className="h5">Purpose of collection</h3>
              </div>
              <p className="landing-bg_para">
                We shall collect your Personal Information or Sensitive personal
                data or information only for specific, clear and lawful
                purposes. These include:
              </p>
              <div className="landing-bg_para">
                <div className="landing-bg_para">
                  to give the User a safe, efficient, smooth and personalised
                  experience while using our Website;
                </div>
                <div className="landing-bg_para">
                  to improve our services and products;
                </div>
                <div className="landing-bg_para">
                  to respond to your queries or complaints generally related to
                  our services, etc;
                </div>
                <div className="landing-bg_para">
                  to send promotional emails containing information about our
                  existing and new products/services, newsletters, notify
                  changes in this Policy or other policies etc;
                </div>
                <div className="landing-bg_para">
                  to analyse the traffic on our Website and conduct market
                  research regarding users’ demographics, interests, and
                  behaviour;
                </div>
                <div className="landing-bg_para">
                  to create new products and services;
                </div>
                <div className="landing-bg_para">
                  to provide customer support services;
                </div>
                <div className="landing-bg_para">
                  to detect, prevent and address error, fraud, criminal
                  activity, abuse of our services and technical issues;
                </div>
                <div className="landing-bg_para">
                  to enforce Terms of Conditions;
                </div>
                <div className="landing-bg_para">
                  to provide co-branded services in affiliation with more than
                  one corporate entity;
                </div>
                <div className="landing-bg_para">
                  other such lawful purposes as described at the time of
                  collection of Personal Information or Sensitive personal data
                  or information.
                </div>
              </div>

              <div className="landing-bg_para">
                <h3 className="h5">How information is collected</h3>
              </div>
              <p className="landing-bg_para">
                We collect information which the User voluntarily provides us at
                the time of visiting, accessing, browsing and using our Website,
                our social media profiles, and customer support service. We also
                collect data automatically by analysing your online behaviour
                (through cookies).
              </p>
              <p className="landing-bg_para">
                The User has an option to not provide us with certain
                information or withdraw consent to provide certain information
                at any time, in accordance with the terms of this Policy. In
                case consent is withdrawn, we shall retain your Personal
                Information or Sensitive personal data or information for a
                period deemed appropriate by us or as mandated by law. On
                revoking of your consent, we reserve the right to limit access
                to the various features and services provided on the Website.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">Disclosure of information</h3>
              </div>
              <p className="landing-bg_para">
                You expressly consent to and authorize us to share your Personal
                Information and Sensitive personal data or information with our
                trusted affiliates and any other third party, to the extent and
                for the lawful purposes as stated in this Policy. We shall not
                disclose any Personal Information or Sensitive personal data or
                information to any government institution or authority, except
                where such disclosure is (i) obligated by law, (ii) requested by
                a lawfully authorized government authority, (iii) pursuant to a
                judicial decree, (iv) for enforcing and protecting the legal
                rights of We2Pay or others’, (v) for seeking any relief, (vi)
                for defending any charge, (vii) for opposing any claim, (viii)
                for enforcing this Policy or our Terms of Use, (ix) for
                obtaining any legal advice. We also reserve our right to
                disclose, share or transfer your Personal Information or
                Sensitive personal data or information to a third party due to
                any change in ownership, merger, restructuring or sale of our
                business assets.
              </p>

              <div className="landing-bg_para">
                <h3>Use of cookies and other technologies</h3>
              </div>
              <p className="landing-bg_para">
                To improve the effectiveness and usability of the Website for
                our Users, we use “cookies”, or similar technology to collect
                information and assign each visitor a unique random number
                called as a User Identification (User ID) in order to understand
                the User's individual interests. Our web servers automatically
                collect limited information about the User’s computer connection
                to the Internet, including User’s IP address, when the User
                visits the Website (User’s IP address is a number that lets
                computers connected to the internet know where to send data to
                the User such as the web pages viewed by the User).
              </p>
              <p className="landing-bg_para">
                Users may encounter “cookies” or other similar devices on
                certain pages of the Website that are placed by third parties.
                We do not control the use of cookies by third parties and
                disclaim any obligation or liability associated thereto.
              </p>

              <div className="landing-bg_para">
                <h3>Links to other websites</h3>
              </div>
              <p className="landing-bg_para">
                The Website provides links to other websites which may or may
                not collect information about the User. The User acknowledges
                that this Policy does not cover the collection and use of
                information by such sites and that we shall not be responsible
                for the privacy policies, practices or content of the linked
                websites.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">Correction and updation of information</h3>
              </div>
              <p className="landing-bg_para">
                The User shall promptly notify us in case any Personal
                Information or Sensitive personal data or information supplied
                by such User as maintained in our records is inaccurate,
                misleading or incomplete. Further, the User may also review,
                update or modify the information by logging into their Account
                on the Website. We shall not be responsible for the authenticity
                of Personal Information or Sensitive personal data or
                information supplied by a User.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">Retention of information</h3>
              </div>
              <p className="landing-bg_para">
                Your Personal Information and Sensitive personal data or
                information may be retained and used until: (i) the relevant
                purposes for the use of your information described in this
                Policy are no longer applicable; and (ii) we are no longer
                required by applicable law, regulations, contractual obligations
                or legitimate business purposes to retain your information; and
                (iii) the retention of your information is not required for the
                establishment, exercise or defense of any legal claim.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">Mailers</h3>
              </div>
              <p className="landing-bg_para">
                We2Pay may send direct mailers to the User at the email address
                given by the User. The User has the option to opt-out of this
                direct mailer by way of links provided at the bottom of each
                mailer or any other means as We2Pay deems appropriate. We2Pay
                respects every User’s privacy and in the event that User chooses
                to not receive such mailers, We2Pay will take all steps to
                remove the User from the list. If a User wants to remove
                his/her/it’s contact information from all mailing lists and
                newsletters, the same can be done through “Profile” page of
                his/her/it’s account with We2Pay.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">Advertising</h3>
              </div>
              <p className="landing-bg_para">
                We use third-party advertising companies to serve ads when you
                visit our Website. These companies may use your anonymized
                information (i.e. information which does not include your name,
                address, email address or mobile number) in order to provide
                advertisements about goods and services of interest to you. Such
                anonymized information is usually in the form of aggregated
                statistics on traffic to various pages within our Website.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">Data Localization</h3>
              </div>
              <p className="landing-bg_para">
                In compliance with Reserve Bank of India’s circular
                RBI/2017-18/153 DPSS.CO.ODNo.2785/06.08.005/2017-2018 dated
                April 6, 2018, all Users, including system participants, service
                providers, intermediaries, payment gateways, third party vendors
                and other entities in the payments ecosystem, who are retained
                or engaged by We2Pay for providing payment services shall
                mandatorily store entire Payment Data in systems located only in
                India. Notwithstanding the above, for cross border transaction
                data, consisting of a foreign component and a domestic
                component, a copy of the domestic component may also be stored
                abroad, if required.
              </p>

              <div className="landing-bg_para">
                <h3 className="h5">How we secure the information</h3>
              </div>
              <p className="landing-bg_para">
                The Website has put stringent security measures necessary to
                prevent misuse, unauthorised access, modification, disclosure or
                destruction of your Personal Information and Sensitive personal
                data or information in our control. All information collected by
                us is stored on servers secured behind a firewall; such servers
                are password-protected and access is strictly limited based on
                need-to-know basis.
              </p>
              <p className="landing-bg_para">
                We may undertake periodic review of our security safeguards and
                this Policy to incorporate such future changes as may be
                appropriate to ensure that integrity of your Personal
                Information and Sensitive personal data or information is
                intact. In case of any security breach which is likely to cause
                harm to the User, we shall notify the User of such breach as
                soon as practicable and take necessary measures to remedy the
                breach or mitigate any immediate harm.
              </p>
              <p className="landing-bg_para">
                If you seek any clarifications regarding this Policy or wish to
                raise any issue or grievance with respect to illegal access, use
                or disclosure of Personal Information, please e-mail at
                help@instantpay.in
              </p>
              <p className="landing-bg_para">
                We shall attempt to resolve any issues within a period of thirty
                (30) days from the date of receipt of the question, concern,
                grievance or report.
              </p>
            </div>
          </Box>
        </div>
      </Container>
    </div>
  );
};

export default PrivacyPolicyView;
